import React from "react";
import { Typography } from "@material-ui/core";

const MatchDialogTitle = ({ match, isEdit = false }) => {
	const { isSingle } = match;

	return (
		<>
			<Typography variant="h3">
				{isSingle
					? `${isEdit ? "Edit" : "Add"} Single Match`
					: `${isEdit ? "Edit" : "Add"} Doubles Match`}
			</Typography>
			<Typography variant="subtitle2">
				Select the players and enter the results for each match.
			</Typography>
		</>
	);
};

export default MatchDialogTitle;
